import axios from "axios";
class OrganisationService {

    axios(){
        return axios.create({
            baseURL: "/organisation",
            headers:{
                'x-api-key': window.env.VUE_APP_ORGANISATIONSERVICEKEY
            },
            timeout : window.env.VUE_APP_TIMEOUT_SECONDE_SEARCH_BAR * 1000
        })
    }
    searchCompanies(query, page = 1, limit = 10, status = null) {
        const body = { ...query };
        if (status) {
            body.status = status;
        }
        return this.axios().post(`/search/companies?country=FR&page=${page}&limit=${limit}`, body);
    }

    getSiteByCompany(companyId, page = 1, limit = 30, status = null) {
        const statusParam = status ? `&status=${status}` : '';
        return this.axios().get(`/FR/companies/${companyId}/sites?page=${page}&limit=${limit}${statusParam}`);
    }

    getSiteBySiret(siteId) {
        return this.axios().get(`/FR/sites/${siteId}`);
    }

}
export default new OrganisationService();
